import PropTypes from 'prop-types';

// Prop types for a GraphQL package
export const PackagePropTypes = {
  details: PropTypes.shape({
    displayName: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }).isRequired,
  skuCost: PropTypes.arrayOf(
    PropTypes.shape({
      skuType: PropTypes.string.isRequired,
      cost: PropTypes.number.isRequired,
    })
  ).isRequired,
  package: PropTypes.string.isRequired,
};

export const PackageListPropTypes = PropTypes.arrayOf(PropTypes.shape(PackagePropTypes));

/**
 * These are just ports of defined Typescript types/interfaces elsewhere.
 * Some day, we'll just be able to use those interfaces instead.
 */
export const FeatureTooltipPropTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export const FeaturePropTypes = {
  summaryLine: PropTypes.string.isRequired,
  tooltip: PropTypes.shape(FeatureTooltipPropTypes).isRequired,
  hidden: PropTypes.bool,
};

export const PackageSummaryPropTypes = {
  features: PropTypes.arrayOf(PropTypes.shape(FeaturePropTypes)).isRequired,
  headerRenderer: PropTypes.func.isRequired,
  footerRenderer: PropTypes.func.isRequired,
};

export const PackageComparisonPropTypes = {
  byline: PropTypes.string.isRequired,
  features: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.bool, PropTypes.string])).isRequired,
  ctaRenderer: PropTypes.func.isRequired,
};

export const SummaryPackageConfigPropTypes = {
  summary: PropTypes.shape(PackageSummaryPropTypes).isRequired,
  comparison: PropTypes.shape(PackageComparisonPropTypes),
};

export const SummaryPackagesConfigPropTypes = PropTypes.objectOf(PropTypes.shape(SummaryPackageConfigPropTypes));

export const ComparisonTableFeaturePropTypes = {
  title: PropTypes.string.isRequired,
  tooltip: PropTypes.string,
};

export const ComparisonTableCategoryFeaturesPropTypes = PropTypes.objectOf(
  PropTypes.shape(ComparisonTableFeaturePropTypes)
);

export const ComparisonTableCategoryPropTypes = {
  title: PropTypes.string.isRequired,
  features: ComparisonTableCategoryFeaturesPropTypes.isRequired,
};

export const ComparisonTablePropTypes = PropTypes.arrayOf(PropTypes.shape(ComparisonTableCategoryPropTypes));

export const RibbonTextOverridePropType = PropTypes.oneOfType([PropTypes.string, PropTypes.bool]);
